export const VIEW_POLICY_INFO = 'VIEW_POLICY_INFO';
